var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1516 12.0428C3.07281 12.0428 1.33943 12.0428 0.55153 12.0428C0.131317 12.0428 0 11.8856 0 11.4924C0 10.4441 0 9.36952 0 8.32117C0 7.90182 0.15758 7.77078 0.55153 7.77078H3.1516C3.1516 7.69216 3.1516 6.17205 3.1516 5.46441C3.1516 4.41606 3.33544 3.42013 3.86071 2.50282C4.41224 1.5593 5.20014 0.930293 6.19815 0.56337C6.85473 0.327491 7.51132 0.222656 8.22043 0.222656H10.7942C11.1619 0.222656 11.3195 0.379909 11.3195 0.746832V3.73463C11.3195 4.10155 11.1619 4.25881 10.7942 4.25881C10.0851 4.25881 9.37601 4.25881 8.6669 4.28502C7.95779 4.28502 7.59011 4.62573 7.59011 5.35957C7.56384 6.14584 7.59011 6.90589 7.59011 7.71836H10.6367C11.0569 7.71836 11.2144 7.87562 11.2144 8.29496V11.4662C11.2144 11.8856 11.0831 12.0166 10.6367 12.0166C9.69117 12.0166 7.6689 12.0166 7.59011 12.0166V20.5607C7.59011 21.0062 7.45879 21.1635 6.98605 21.1635C5.88299 21.1635 4.80619 21.1635 3.70313 21.1635C3.30918 21.1635 3.1516 21.0062 3.1516 20.6131C3.1516 17.8612 3.1516 12.1214 3.1516 12.0428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.a3099cd8731bbdb31b5d14de038b813b.svg";
export { ForwardRef as ReactComponent };